import { Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
import { EditDeliveryAddress } from './EditDeliveryAddress/EditDeliveryAddress';
export var ShippingAddress = function (_a) {
    var _b, _c, _d, _e, _f;
    var deliveryData = _a.deliveryData, buttonSettings = _a.buttonSettings;
    if (!deliveryData)
        return null;
    var _g = (_c = (_b = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.deliveryAddress) === null || _b === void 0 ? void 0 : _b.postalDetails) !== null && _c !== void 0 ? _c : {}, _h = _g.addressLine1, addressLine1 = _h === void 0 ? '' : _h, _j = _g.addressLine2, addressLine2 = _j === void 0 ? '' : _j, _k = _g.city, city = _k === void 0 ? '' : _k, _l = _g.state, state = _l === void 0 ? '' : _l, _m = _g.zipCode, zipCode = _m === void 0 ? '' : _m;
    var _o = (_e = (_d = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.deliveryAddress) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : {}, _p = _o.firstName, firstName = _p === void 0 ? '' : _p, _q = _o.lastName, lastName = _q === void 0 ? '' : _q;
    var _r = deliveryData, _s = _r.streetNumber, streetNumber = _s === void 0 ? '' : _s, _t = _r.streetType, streetType = _t === void 0 ? '' : _t, _u = _r.city, toAddressCity = _u === void 0 ? '' : _u, _v = _r.state, toAddressState = _v === void 0 ? '' : _v, _w = _r.zip, toAddressZip = _w === void 0 ? '' : _w, _x = _r.lastName, toLastName = _x === void 0 ? '' : _x, _y = _r.firstName, toFirstName = _y === void 0 ? '' : _y;
    var shippingCity = city || toAddressCity;
    var shippingState = state || toAddressState;
    var shippingZip = zipCode || toAddressZip;
    var isMissingShippingAddress = [
        addressLine1,
        addressLine2,
        streetNumber,
        streetType,
        shippingCity,
        shippingState,
        shippingZip,
    ].every(function (item) { return !item; });
    if (isMissingShippingAddress)
        return null;
    return (React.createElement("div", { "data-testid": "test-shipping-address" },
        React.createElement("div", { className: "sui-flex sui-justify-between" },
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Ship To:"),
            ((_f = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _f === void 0 ? void 0 : _f.isEditDeliveryAddressEnabled) && (React.createElement(EditDeliveryAddress, null))),
        React.createElement("div", { "data-testid": "test-shipping-address-details" },
            React.createElement(Typography, null,
                firstName || toFirstName,
                " ",
                lastName || toLastName),
            React.createElement(Typography, null, addressLine1 || streetNumber + ' ' + streetType),
            addressLine2 && React.createElement(Typography, null, addressLine2),
            React.createElement(Typography, null,
                shippingCity && shippingCity + ', ',
                shippingState + ' ',
                shippingZip))));
};
